/*
 * sn-faq.js — accordéon de la FAQ SN (JS vanilla, aucune dépendance)
 * Questions indépendantes : en ouvrir une ne ferme pas les autres.
 * Animation de la hauteur (max-height) en 0,3 s ; sans JS, les <details> s'ouvrent quand même.
 */
(function () {
  'use strict';

  if (customElements.get('sn-accordion')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  class SnAccordion extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll(':scope > details'));
      this.items.forEach((item) => {
        const summary = item.querySelector('summary');
        if (!summary) return;
        summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
        summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (item.open && !item.classList.contains('is-closing')) {
            this.close(item);
          } else {
            this.open(item);
          }
        });
      });

      // Éditeur de thème : ouvrir la question sélectionnée dans la barre latérale
      this.onBlockSelect = (event) => {
        const item = this.items.find((element) => element.contains(event.target) || element === event.target);
        if (item && !item.open) this.open(item);
      };
      document.addEventListener('shopify:block:select', this.onBlockSelect);
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    getParts(item) {
      return {
        summary: item.querySelector('summary'),
        answer: item.querySelector('.sn-faq__answer'),
      };
    }

    open(item) {
      const { summary, answer } = this.getParts(item);
      item.classList.remove('is-closing');
      item.open = true;
      summary.setAttribute('aria-expanded', 'true');
      if (!answer || reduceMotion.matches) return;

      answer.style.maxHeight = '0px';
      requestAnimationFrame(() => {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        if (item.open && !item.classList.contains('is-closing')) answer.style.maxHeight = '';
      };
      answer.addEventListener('transitionend', onEnd);
    }

    close(item) {
      const { summary, answer } = this.getParts(item);
      summary.setAttribute('aria-expanded', 'false');
      if (!answer || reduceMotion.matches) {
        item.open = false;
        return;
      }

      item.classList.add('is-closing');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      // force le calcul avant de lancer la transition vers 0
      answer.getBoundingClientRect();
      requestAnimationFrame(() => {
        answer.style.maxHeight = '0px';
      });
      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.removeEventListener('transitionend', onEnd);
        if (item.classList.contains('is-closing')) {
          item.open = false;
          item.classList.remove('is-closing');
          answer.style.maxHeight = '';
        }
      };
      answer.addEventListener('transitionend', onEnd);
    }
  }

  customElements.define('sn-accordion', SnAccordion);
})();
